module.exports = __webpack_public_path__ + "media/images/icons/twitter-51c0e88c2e0d712d5badee4be5870d47.svg";